import type { QueryClient } from '@tanstack/react-query';

/**
 * localStorage key used by the async-storage persister configured in `router.tsx`.
 * Kept in sync with the explicit `key` passed to `createAsyncStoragePersister`.
 */
export const PERSISTED_QUERY_CACHE_KEY = 'REACT_QUERY_OFFLINE_CACHE';

/**
 * Drop all cached query data from BOTH the in-memory client and the persisted
 * localStorage blob.
 *
 * `queryClient.clear()` only updates memory; the persister writes to localStorage
 * on a ~1s throttle, so we remove the key directly to guarantee a stale copy isn't
 * restored on the next load. Call this on auth transitions (login / logout / NGO
 * switch) so a session never inherits the previous state's cache — otherwise a
 * persisted `{ unauthenticated: true }` (a successful ngo.* query *result*) is
 * restored and read synchronously, bouncing a freshly-authenticated user back to
 * /login before the cookie-backed refetch can land.
 */
export function clearPersistedQueryCache(queryClient: QueryClient): void {
	queryClient.clear();
	if (typeof window !== 'undefined') {
		window.localStorage.removeItem(PERSISTED_QUERY_CACHE_KEY);
	}
}
